import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Service Area',
    href: '#service-area'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 border-b border-gray-100 shadow-sm" data-id="element-56">
      <div className="container mx-auto px-4 md:px-6" data-id="element-57">
        <div className="flex h-16 md:h-20 items-center justify-between" data-id="element-58">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-59">
            <a href="#" className="flex items-center gap-2" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/3eDftEpgU66e1cJe6MrY2N/ChatGPT_Image_Feb_18,_2026,_02_06_59_PM.png" alt="EZAZ Window Cleaning Logo" className="h-10 md:h-12 w-auto object-contain" data-id="element-61" />
              <span className="text-xl md:text-2xl font-bold text-navy hidden sm:block" data-id="element-62">
                EZAZ
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-63">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-700 hover:text-navy transition-colors" data-id="element-64">
                {link.name}
              </a>)}
            <a href="tel:4805550123" className="flex items-center gap-2 text-navy font-semibold hover:text-gold transition-colors" data-id="element-65">
              <Phone className="h-4 w-4" data-id="element-66" />
              (480) 555-0123
            </a>
            <Button variant="secondary" size="sm" data-id="element-67">
              Get a Free Quote
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-navy" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-68">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-69" /> : <Menu className="h-6 w-6" data-id="element-70" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-71">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-4" data-id="element-72">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-gray-700 hover:text-navy py-2 border-b border-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-73">
                {link.name}
              </a>)}
            <a href="tel:4805550123" className="flex items-center gap-2 text-navy font-semibold py-2" data-id="element-74">
              <Phone className="h-4 w-4" data-id="element-75" />
              (480) 555-0123
            </a>
            <Button variant="secondary" className="w-full mt-2" data-id="element-76">
              Get a Free Quote
            </Button>
          </div>
        </div>}
    </header>;
}